import type { BuildState } from '../types';

const STAT_TABLES = {
  weapon:  { weapon_cannon: 2, weapon_twin: 3, weapon_laser: 3, weapon_pod: 4, weapon_gatling: 5, weapon_beam: 5, weapon_railgun: 6, weapon_plasma: 4, weapon_torpedo: 5, weapon_burst: 4 },
  wingtip: { wingtip_pod: 2, wingtip_missile: 2, wingtip_bomb: 3, wingtip_light: 0, wingtip_antenna: 0, wingtip_thruster: 0, wingtip_spike: 1, wingtip_claw: 1, wingtip_gun: 2, wingtip_blade: 1 },
  engine:  { engine_single: 2, engine_twin: 3, engine_bell: 2, engine_triple: 4, engine_ring: 3, engine_box: 1, engine_pulse: 5, engine_cluster: 4, engine_nacelle: 3, engine_afterburner: 5 },
  hull:    { hull_wedge: { armor: 3, manBase: 3 }, hull_round: { armor: 3, manBase: 2 }, hull_arrow: { armor: 1, manBase: 5 }, hull_freighter: { armor: 5, manBase: 1 }, hull_cross: { armor: 2, manBase: 4 }, hull_crab: { armor: 4, manBase: 2 }, hull_dreadnought: { armor: 6, manBase: 1 }, hull_interceptor: { armor: 1, manBase: 6 }, hull_gunship: { armor: 5, manBase: 2 } },
  wing:    { wing_swept: 3, wing_delta: 4, wing_forked: 3, wing_stub: 1, wing_long: 4, wing_gull: 3, wing_spike: 5, wing_bowed: 3, wing_canard: 5, wing_broad: 2 },
} as const;

export const shipComputeStats = (b: BuildState): Record<string, number> => {
  const s = { firepower: 0, speed: 0, armor: 0, maneuver: 0 };
  if (b.weapon) s.firepower += (STAT_TABLES.weapon as Record<string,number>)[b.weapon] ?? 0;
  if (b.muzzle) s.firepower += 1;
  if (b.wingtip) s.firepower += (STAT_TABLES.wingtip as Record<string,number>)[b.wingtip] ?? 0;
  if (b.engine) s.speed += (STAT_TABLES.engine as Record<string,number>)[b.engine] ?? 0;
  if (b.exhaust) s.speed += 1;
  if (b['hull']) {
    const h = (STAT_TABLES.hull as Record<string,{armor:number;manBase:number}>)[b['hull']];
    if (h) { s.armor = h.armor; s.maneuver = h.manBase; }
  }
  if (b.wing) s.maneuver += (STAT_TABLES.wing as Record<string,number>)[b.wing] ?? 0;
  return s;
};
